import { makeStyles } from '@material-ui/core';

export const inputUseStyles = makeStyles(
    (theme) => ({
        root: {},
        underline: {
            '&:after': {
                borderBottomColor: theme.palette.secondary.main,
            },
        },
        actHealthColors: {
            '&$underline:after': {
                borderBottomColor: theme.palette.actHealth.main,
            },
            '&$focused $startAdornment': {
                color: theme.palette.actHealth.main,
            },
            '&$focused $endAdornment': {
                color: theme.palette.actHealth.main,
            },
        },
        startAdornment: {
            opacity: 0.5,
            '$focused &': {
                opacity: 1,
                color: theme.palette.secondary.main,
            },
            '$error &': {
                opacity: 1,
                color: theme.palette.error.main,
            },
            padding: theme.spacing(0, 1, 0, 1),
        },
        endAdornment: {
            opacity: 0.5,
            '$focused &': {
                opacity: 1,
                color: theme.palette.secondary.main,
            },
            '$error &': {
                opacity: 1,
                color: theme.palette.error.main,
            },
            padding: theme.spacing(0, 0, 0, 1),
        },
        focused: {},
        error: {},
    }),
    { name: 'EDFWeb-Input-TextField-Component-Input' }
);
